import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-virtual-earrings"
    path="business/products/ar-virtual-earrings"
    element={<AsyncPage />}
  />,
  <Route
      key="/business/products/virtual-accessories"
      path="business/products/virtual-accessories"
      element={<AsyncPage />}
  />,
];
